import { render, staticRenderFns } from "./ViewReceipts.vue?vue&type=template&id=6c92a96a"
import script from "./ViewReceipts.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewReceipts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports